/** Fixed interval in milliseconds for ignoring repeated submit gestures. */
export const SUBMIT_LOCK_MS = 1000;
//# sourceMappingURL=submitLock.js.map